import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { useCookieConsent } from "@/context/CookieConsentContext";

export const Footer = () => {
  const { config } = useSiteConfig();
  const { openPreferences } = useCookieConsent();
  return (
  <footer className="relative text-white" style={{ background: "var(--elsa-blue)" }} data-testid="footer">
    {/* subtle top accent line */}
    <div className="h-px w-full bg-white/15" />

    <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-x-12 gap-y-14">
        {/* CTA */}
        <div className="lg:col-span-5">
          <div className="mb-8">
            <img src="/elsa-logo-white.png" alt="ELSA Brussel" className="h-16 w-auto object-contain" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl leading-[0.98] text-balance">
            Word deel van de volgende generatie juristen.
          </h2>
          <Link
            to="/lid-worden"
            data-testid="footer-join-btn"
            className="group inline-flex items-center gap-2 mt-8 text-sm font-600 px-6 py-3 rounded-full bg-white text-[#0A3087] transition-transform hover:-translate-y-0.5"
          >
            Sluit je aan
            <ArrowUpRight size={17} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        {/* Nav */}
        <div className="lg:col-span-2 lg:col-start-7">
          <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Navigatie</p>
          <ul className="space-y-2.5 text-white/75 text-sm">
            {[["Home", "/"], ["Team", "/team"], ["Events", "/events"], ["Partners", "/partners"], ["Netwerk", "/netwerk"], ["Lid worden", "/lid-worden"], ["Contact", "/contact"]].map(([l, t]) => (
              <li key={t}><Link to={t} className="hover:text-white transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="lg:col-span-3">
          <p className="text-xs uppercase tracking-widest text-white/40 mb-4">Contact</p>
          <ul className="space-y-3 text-white/75 text-sm">
            <li className="flex gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-white/50" /> {config.contact_address}</li>
            <li className="flex gap-2.5"><Mail size={16} className="mt-0.5 shrink-0 text-white/50" /> <a href={`mailto:${config.contact_email}`} className="hover:text-white transition-colors whitespace-nowrap">{config.contact_email}</a></li>
          </ul>
          <div className="flex gap-3 mt-5">
            {config.instagram_url && <a href={config.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-9 w-9 grid place-items-center rounded-full border border-white/20 hover:bg-white hover:text-[#0A3087] transition-colors"><Instagram size={16} /></a>}
            {config.linkedin_url && <a href={config.linkedin_url} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-9 w-9 grid place-items-center rounded-full border border-white/20 hover:bg-white hover:text-[#0A3087] transition-colors"><Linkedin size={16} /></a>}
          </div>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-white/12 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/40">
        <p>© {new Date().getFullYear()} ELSA Brussel — European Law Students' Association.</p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/privacybeleid" data-testid="footer-privacy-link" className="hover:text-white/70 transition-colors">Privacybeleid</Link>
          <button onClick={openPreferences} data-testid="footer-cookie-prefs" className="hover:text-white/70 transition-colors">Cookievoorkeuren aanpassen</button>
          <Link to="/admin/login" className="hover:text-white/70 transition-colors">Beheer</Link>
        </div>
      </div>
      <p className="mt-4 text-[11px] text-white/30" data-testid="footer-credit">Website door M.Panahy</p>
    </div>
  </footer>
  );
};
